import Const from 'constants';
import AppLocalStorage from 'storages/app-local-storage';
import {BASE_PATH} from 'config';
import {getPlayerService} from 'services/sports/factory';
import Action from 'actions';

function createStorageId(sportConfig) {
    return sportConfig.getSport() + '_' + sportConfig.getSite();
}

let Storage = {
    saveFiltersToStorage(filterType) {
        return (dispatch, getState) => {
            const {
                sportConfig,
                playersData: {players, filters},
            } = getState();

            if (!sportConfig.isReady()) {
                return;
            }

            const sportConfigFilters = {
                [BASE_PATH]: {
                    sport: sportConfig.getSport(),
                    site: sportConfig.getSite(),
                    gameType: sportConfig.getGameType(),
                    slateId: sportConfig.getSlateId(),
                    mode: sportConfig.getMode(),
                },
            };
            AppLocalStorage.setValue('sportConfigFilters', JSON.stringify(sportConfigFilters));

            const storageId = sportConfig.getSport() + '_' + sportConfig.getSite();
            const slateId = sportConfig.getSlateId();

            let storage = AppLocalStorage.getValue('filters');
            storage = storage.length ? JSON.parse(storage) : {};

            if (!storage.hasOwnProperty(storageId)) {
                storage[storageId] = {};
            }
            if (!storage[storageId].hasOwnProperty(slateId)) {
                storage[storageId][slateId] = {};
            }

            if ('playersData' === filterType) {
                const playersList = players.all();
                if (!isEmpty(playersList)) {
                    const userPoints = [];
                    const pointsChangedManually = [];
                    const userLineGroups = [];
                    const userPPLine = [];

                    Object.values(playersList).map((player) => {
                        if (Number(player.adminPoints) !== Number(player.userPoints)) {
                            userPoints.push({
                                playerId: player.playerId,
                                userPoints: player.userPoints,
                            });
                        }

                        if (player.userLineGroup !== player.lineGroup) {
                            userLineGroups.push({
                                playerId: player.playerId,
                                userLineGroup: player.userLineGroup,
                            });
                        }

                        if (player.userPpLine !== player.ppLine) {
                            userPPLine.push({
                                playerId: player.playerId,
                                userPpLine: player.userPpLine,
                            });
                        }

                        if (player.pointsChangedManually) {
                            pointsChangedManually.push(player.playerId);
                        }
                    });

                    storage[storageId][slateId]['userPoints'] = userPoints;
                    storage[storageId][slateId]['pointsChangedManually'] = pointsChangedManually;
                    storage[storageId][slateId]['userLineGroups'] = userLineGroups;
                    storage[storageId][slateId]['userPPLine'] = userPPLine;
                }

                const extraData = getPlayerService(sportConfig).exec('getExtraPlayerDataToStore', {}, {});

                storage[storageId][slateId] = {...storage[storageId][slateId], ...extraData};
                storage[storageId][slateId]['gameType'] = sportConfig.getGameType();
            } else if ('selectedGames' === filterType) {
                storage[storageId][slateId]['filterGames'] = filters.games;
            }

            AppLocalStorage.setValue('filters', JSON.stringify(storage));
        };
    },
    saveDataToStorage(key, callback) {
        return (dispatch, getState) => {
            const state = getState();
            const {sportConfig} = state;

            if (!sportConfig.isReady()) {
                return;
            }

            const storageId = createStorageId(sportConfig);
            const slateId = sportConfig.getSlateId();
            const storage = AppLocalStorage.getObject('filters');

            storage[storageId] ??= {};
            storage[storageId][slateId] ??= {};
            storage[storageId][slateId][key] = callback(state, storage[storageId][slateId][key] || null);

            AppLocalStorage.setValue('filters', JSON.stringify(storage));
        };
    },
    clearDataInStorage() {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            if (!sportConfig.isReady()) {
                return;
            }

            const storageId = createStorageId(sportConfig);
            const slateId = sportConfig.getSlateId();
            const storage = AppLocalStorage.getObject('filters');

            storage[storageId] ??= {};
            storage[storageId][slateId] = {};

            AppLocalStorage.setValue('filters', JSON.stringify(storage));
        };
    },
    clearOutdatedFiltersInStorage(slateIds) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            const storageId = createStorageId(sportConfig);
            let isUpdated = false;

            const storage = AppLocalStorage.getObject('filters');

            if (!storage.hasOwnProperty(storageId)) {
                return;
            }

            Object.keys(storage[storageId]).map((slateId) => {
                if (!storage[storageId][slateId]['gameType']) {
                    return;
                }
                if (sportConfig.getGameType() !== storage[storageId][slateId]['gameType']) {
                    return;
                }
                if (!inArray(Number(slateId), slateIds)) {
                    delete storage[storageId][slateId];
                    isUpdated = true;
                }
            });

            if (isUpdated) {
                AppLocalStorage.setValue('filters', JSON.stringify(storage));
            }
        };
    },
    loadFiltersFromStorage(filterType) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            if (!sportConfig.isReady()) {
                return;
            }

            let storage = AppLocalStorage.getValue('filters');
            storage = storage.length ? JSON.parse(storage) : {};

            if (isEmpty(storage)) {
                return;
            }

            const storageId = sportConfig.getSport() + '_' + sportConfig.getSite();
            const slateId = sportConfig.getSlateId();

            if (!storage.hasOwnProperty(storageId) || !storage[storageId].hasOwnProperty(slateId)) {
                return;
            }

            const slateStore = storage[storageId][slateId];

            if ('selectedGames' === filterType) {
                if (slateStore.hasOwnProperty('filterGames')) {
                    dispatch(this.setGamesFilter(slateStore['filterGames'], {saveFilters: false}));
                }
            } else if ('updatePoints' === filterType) {
                if (slateStore.hasOwnProperty('userPoints')) {
                    let pointsChangedManually = false;
                    if (slateStore.hasOwnProperty('pointsChangedManually')) {
                        pointsChangedManually = slateStore['pointsChangedManually'];
                    }
                    dispatch(this.setUserPoints(slateStore['userPoints'], Const.FLEX_MODE, pointsChangedManually));
                }

                if (slateStore.hasOwnProperty('userLineGroups')) {
                    dispatch(this.setUserLineGroups(slateStore['userLineGroups']));
                }

                if (slateStore.hasOwnProperty('userPPLine')) {
                    dispatch(this.setUserPPLine(slateStore['userPPLine']));
                }
            } else if ('pointsType' === filterType) {
                if (slateStore.hasOwnProperty('projectionPointsType')) {
                    dispatch(this.setProjectionPointsTypeFromStorage(slateStore['projectionPointsType']));
                }

                if (slateStore.hasOwnProperty('userPointsType')) {
                    dispatch(this.setUserPointsTypeFromStorage(slateStore['userPointsType']));
                }
            } else {
                if (slateStore.hasOwnProperty('userPoints')) {
                    let pointsChangedManually = false;
                    if (slateStore.hasOwnProperty('pointsChangedManually')) {
                        pointsChangedManually = slateStore['pointsChangedManually'];
                    }
                    dispatch(this.setUserPoints(slateStore['userPoints'], Const.FLEX_MODE, pointsChangedManually));
                }

                if (slateStore.hasOwnProperty('userExposure')) {
                    dispatch(this.setPlayersExposureFromStorage(slateStore['userExposure']));
                }

                if (slateStore.hasOwnProperty('sympathy')) {
                    dispatch(this.setPlayersSympathyFromStorage(slateStore['sympathy']));
                }

                if (slateStore.hasOwnProperty('playersPosition')) {
                    dispatch(this.setPlayersPositionFromStorage(slateStore['playersPosition']));
                }

                if (slateStore.hasOwnProperty('uniquePlayersQuantity')) {
                    dispatch(this.setUniquePlayersQuantityFromStorage(slateStore['uniquePlayersQuantity']));
                }

                if (slateStore.hasOwnProperty('showPlayersExposureWhileOptimized')) {
                    dispatch(this.setShowPlayersExposureWhileOptimizedFromStorage(slateStore['showPlayersExposureWhileOptimized']));
                }

                if (slateStore.hasOwnProperty('prioritizeCompletingLineupsAboveExp')) {
                    dispatch(this.setPrioritizeCompletingLineupsAboveExpFromStorage(slateStore['prioritizeCompletingLineupsAboveExp']));
                }

                if (slateStore.hasOwnProperty('projectedOwnershipForce')) {
                    dispatch(this.setProjectedOwnershipForceFromStorage(slateStore['projectedOwnershipForce']));
                }

                if (slateStore.hasOwnProperty('lineupsQuantity')) {
                    dispatch(this.setLineupsQuantityFromStorage(slateStore['lineupsQuantity']));
                }

                if (slateStore.hasOwnProperty('userLineGroups')) {
                    dispatch(this.setUserLineGroups(slateStore['userLineGroups']));
                }

                if (slateStore.hasOwnProperty('userPPLine')) {
                    dispatch(this.setUserPPLine(slateStore['userPPLine']));
                }

                if (slateStore.hasOwnProperty('filterExcluded')) {
                    dispatch(this.setExcludedPlayersFromStorage(slateStore['filterExcluded']));
                }

                if (slateStore.hasOwnProperty('filterLocked')) {
                    dispatch(this.setLockedPlayersFromStorage(slateStore['filterLocked']));
                }

                if (slateStore.hasOwnProperty('pointsBoundary')) {
                    dispatch(this.setInnerPointsBoundaryFromStorage(slateStore['pointsBoundary']));
                }

                if (slateStore.hasOwnProperty('salaryBoundary')) {
                    const {innerBoundaries} = slateStore['salaryBoundary'];
                    dispatch(this.setInnerSalaryBoundaryFromStorage(innerBoundaries));
                }

                if (slateStore.hasOwnProperty('salaryCap')) {
                    const {innerCapBoundaries} = slateStore['salaryCap'];
                    dispatch(this.setInnerSalaryCapFromStorage(innerCapBoundaries));
                }

                if (slateStore.hasOwnProperty('projectedOwnershipCap')) {
                    const {innerCapBoundaries} = slateStore['projectedOwnershipCap'];
                    dispatch(this.setInnerProjectedOwnershipCapFromStorage(innerCapBoundaries));
                }

                if (slateStore.hasOwnProperty('exposureMode')) {
                    dispatch(this.setExposureModeFromStorage(slateStore['exposureMode']));
                }

                if (slateStore.hasOwnProperty('rangeOfOutcomes')) {
                    dispatch(this.setRangeOfOutcomesFromStorage(slateStore['rangeOfOutcomes']));
                }

                if (slateStore.hasOwnProperty('opposingPlayers')) {
                    dispatch(this.setOpposingPlayersFromStorage(slateStore['opposingPlayers']));
                }

                if (slateStore.hasOwnProperty('generatorType')) {
                    dispatch(this.setGeneratorTypeFromStorage(slateStore['generatorType']));
                }

                if (slateStore.hasOwnProperty('playerCombinationStacking')) {
                    dispatch(this.setPlayerCombinationStackingSettingsFromStorage(slateStore['playerCombinationStacking']));
                }

                if (slateStore.hasOwnProperty('projectedOwnerships')) {
                    dispatch(this.setProjectedOwnershipsFromStorage(slateStore['projectedOwnerships']));
                }

                if (slateStore.hasOwnProperty('projectionBoostRule')) {
                    dispatch(this.setProjectionBoostRuleFromStorage(slateStore['projectionBoostRule']));
                }

                if (slateStore.hasOwnProperty('playerPositionStacking')) {
                    dispatch(this.setPlayerPositionStackingFromStorage(slateStore['playerPositionStacking']));
                }

                getPlayerService(sportConfig).exec('loadExtraPlayerDataFromStore', {dispatch, data: slateStore});
            }
        };
    },
};

export default Storage;
